import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export default function LoadingSpinner({
  size = 150,
  color,
}: {
  size?: number;
  color?: string;
}) {
  return (
    <ClipLoader
      color={color}
      size={size}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  );
}
